import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { SubscriptionPerformance } from '../_models';
import { ArrayResponse, BaseResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPerformanceService {

  constructor(private http: HttpClient) { }

  getAll(filter: any, realtimeFlag: boolean): Observable<ArrayResponse>  { //listing
    return this.http.post(`${environment.apiUrl}/report/subscriber-perf/graph?realtime=${realtimeFlag}`, filter)
    .pipe(
      map((data: ArrayResponse) => {
        if(data.status !== 1 || (data.status == 1 && !data.data)){
          return null;
        }else{
          return new ArrayResponse().deserialize(data, SubscriptionPerformance);
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  export(filter: any, realtimeFlag: boolean): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/report/subscriber-perf/export?realtime=${realtimeFlag}`, filter);
  }
}
